module.exports = __webpack_public_path__ + "img/img_safety_phone_img4.75fec64a.png";